export default class DestinazioneOlio {
	constructor() {
		this.destinazioneD = "0";
		this.destinazioneQ = "0";
		this.destinazioneT = "0";
 	}
}